import { Component, OnInit, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    NgForm,
    Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { AlertService } from './../../alert';
import { ProductCategoryCreateService } from './create.service';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

@Component({
  templateUrl: './create.component.html'
})

export class  ProductCategoryCreateComponent implements OnInit {

  @ViewChild('successModal') successModal: any;

  addProductCatForm: FormGroup;
  name: String = '';

  constructor(
    // private alertService: AlertService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private router: Router,
    private productCatCreateService: ProductCategoryCreateService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en-us');
  }

  ngOnInit() {
      this.createForm();
  }

  public createForm(): void {
    this.addProductCatForm = this.formBuilder.group({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ])
    });
  }

  public addProductCat(addProductCatForm): void {
    this.productCatCreateService
      .create(addProductCatForm.controls)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
        }
      );
  }

  public closeSuccessModel(): void {
    this.router.navigate(['/home/product-category']);
  }

  public continue(): void {
    this.successModal.hide();
    this.router.navigate([this.router.url]);
    this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/create/create.component.ts